import React from "react";
import * as S from "./style";
import { ColorsEnum } from "../../../common/theme/colors";

interface StatusChipProps {
  status: string;
  colorMap?: Record<string, { bg: string; color: string }>;
  size?: "small" | "medium";
}

const StatusChip: React.FC<StatusChipProps> = ({
  status,
  colorMap,
  size = "small",
}) => {
  const defaultMap: Record<string, { bg: string; color: string }> = {
    completed: { bg: ColorsEnum.green, color: ColorsEnum.white },
    failed: { bg: ColorsEnum.error, color: ColorsEnum.white },
    running: { bg: ColorsEnum.machoBlue, color: ColorsEnum.white },
    success: { bg: ColorsEnum.green, color: ColorsEnum.white },
  };

  const map = colorMap || defaultMap;
  const style = map[status] || {
    bg: ColorsEnum.sunshine,
    color: ColorsEnum.gunmetal,
  };

  return (
    <S.StyledStatusChip
      label={status}
      size={size}
      sx={{ bgcolor: style.bg, color: style.color }}
    />
  );
};

export default StatusChip;
